import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";

import { Checkbox, FormControlLabel } from "@material-ui/core";

import {
  asyncMarkParticipantContentAsWatched,
  asyncAssignParticipantContent,
} from "../../actions/contentActions";

import { COMPLETED } from "../../consts/assignedContentStatus";

export const WatchedContent = ({ statusId, contentId }) => {
  const dispatch = useDispatch();
  const { request } = useSelector((state) => ({
    request: state.request.request,
  }));
  const handleChange = (event) => {
    const shouldMarkAsChecked = event.target.checked;
    if (shouldMarkAsChecked) {
      dispatch(asyncMarkParticipantContentAsWatched(contentId));
    } else {
      dispatch(asyncAssignParticipantContent(contentId));
    }
  };
  return (
    <FormControlLabel
      data-testid="completeCheckbox"
      control={
        <Checkbox
          checked={statusId === COMPLETED}
          onChange={handleChange}
          name="completeCheckbox"
          color="primary"
          disabled={request.isFetching}
        />
      }
      label="Watched"
    />
  );
};

WatchedContent.propTypes = {
  statusId: PropTypes.number,
  contentId: PropTypes.number,
};

WatchedContent.defaultProps = {
  statusId: 0,
  contentId: 0,
};
